import React from 'react'
import styles from './Promo.module.css'
import IconPromo1 from '../../../assets/icons/IconPromo1'
import IconPromo2 from '../../../assets/icons/IconPromo2'
import IconPromo3 from '../../../assets/icons/IconPromo3'
import IconPromo4 from '../../../assets/icons/IconPromo4'
import promoMain from '../../../assets/promoMain.png'
import about2 from '../../../assets/about2.png'
import StoreButton, {STORE_TYPE_APPLE, STORE_TYPE_GOOGLE} from './StoreButton/StoreButton'

const PromoItem = ({
    title,
    desc,
    Image,
}) => {
    return (
        <div className={styles.promoItemContainer}>
            <Image size={72} className={styles.promoItemImage} />
            <div className={styles.promoItemInnerContainer}>

                <p className={styles.promoItemTitle}>{title}</p>
                <p className={styles.promoItemDesc}>{desc}</p>


            </div>

        </div>
    )
}

const Promo = ({scrollToRef}) => {
    return (
        <div className={styles.container}>
            <p className={styles.mainTitle}>Everything you need to learn.</p>
            <div className={styles.PromoItemsContainer}>
                <img src={promoMain} className={styles.promoImage} />
                <PromoItem
                    title='Listening training'
                    desc='Shepha lessons are designed to help you to speak with native Israelis'
                    Image={IconPromo1} />
                <PromoItem
                    title='Zero to hero'
                    desc='Shepha teaches alphabet, verbs, nouns, adjectives, grammer rules, and more.'
                    Image={IconPromo2} />
                <PromoItem
                    title='Immediate feedback'
                    desc='Each lesson has a score system to give you feedback how you did in practice'
                    Image={IconPromo3} />
                <PromoItem
                    title='Native experience'
                    desc='We were born and raised in Israel. Everything you learn will give you a first person peak of how we talk in Israel.'
                    Image={IconPromo4} />
            </div>
            <div className={styles.divider}  ref={scrollToRef}/>
            <div className={styles.bottomPromoContainer}>
                <img src={about2} className={styles.bottomPromoImage}/>
                <div className={styles.bottomPromoInnerContainer}>
                    <p className={styles.bottomPromoContainerTitle}>Shepha got you covered</p>
                    <p className={styles.bottomPromoContainerDesc}>We designed this course so your journey will be as profound as possible. we wrote dialoges, texts, sentences, quizes and so much more to give you the best environment to practice your Hebrew</p>
                </div>
            </div>
            <div className={styles.storeButtonContainer}>
                <StoreButton 
                    store={STORE_TYPE_APPLE} 
                    url="https://apps.apple.com/gb/app/shepha-learn-hebrew-language/id1485115845"/>
                <StoreButton 
                    store={STORE_TYPE_GOOGLE} 
                    url="https://play.google.com/store/apps/details?id=com.vinet.shepha"/>
            </div>
        </div>
    )
}

export default Promo
